import { hideOthers } from "aria-hidden";
export {
  hideOthers
};
//# sourceMappingURL=AriaHidden.js.map
